import { render, staticRenderFns } from "./safetyHealthyTargetDetail.vue?vue&type=template&id=b9bb7716"
import script from "./safetyHealthyTargetDetail.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9bb7716')) {
      api.createRecord('b9bb7716', component.options)
    } else {
      api.reload('b9bb7716', component.options)
    }
    module.hot.accept("./safetyHealthyTargetDetail.vue?vue&type=template&id=b9bb7716", function () {
      api.rerender('b9bb7716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyTargetDetail.vue"
export default component.exports